var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextField from 'components/v2/forms/TextField';
export default function InputWithTrailingIcon(_a) {
    var { className, children, dataTestId } = _a, props = __rest(_a, ["className", "children", "dataTestId"]);
    return ((React.createElement("div", { "data-testid": dataTestId, className: classnames('relative rounded-md shadow-sm', className) },
        React.createElement(TextField, Object.assign({ dataTestId: "TextField-458256d7" }, props)),
        React.createElement("div", { "data-testid": "div-00393e45", className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, children))));
}
InputWithTrailingIcon.propTypes = {
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]),
    children: PropTypes.node.isRequired,
};
